export default function assignAddress(basicEntity: any, addressBlob: any) {
    return basicEntity && addressBlob
        ? {
              ...basicEntity,
              ...{
                  streetAddress: addressBlob.streetAddress,
                  addressLocality: addressBlob.addressLocality,
                  addressRegion: addressBlob.addressRegion,
                  addressCountry: addressBlob.addressCountry,
                  postalCode: addressBlob.postalCode,
                  postOfficeBoxNumber: addressBlob.postOfficeBoxNumber,
              },
          }
        : null;
}
